import { useFeatureIsOn as useFeatureIsOnGrowthBook } from '@growthbook/growthbook-react';
import { datadogRum } from '@datadog/browser-rum';

export const useFeatureIsOn = <AppFeatures extends Record<string, unknown> = Record<string, unknown>>(id: string & keyof AppFeatures): boolean => {
    const result = useFeatureIsOnGrowthBook(id);
    datadogRum.addFeatureFlagEvaluation(id, result);
    return result;
};
